module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title170"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781466817081_tp01",
      "id": "toctitle167",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781466817081_fm01",
      "id": "toctitle1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PROLOGUE")])])]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781466817081_p01",
      "id": "toctitle2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART I")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c01",
      "id": "toctitle3"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("1")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Charahan Surp Nishan")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c02",
      "id": "toctitle4"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("2")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Armenians in Ottoman Turkey")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c03",
      "id": "toctitle5"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("3")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Khorkom")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c04",
      "id": "toctitle6"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("4")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Boyhood")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c05",
      "id": "toctitle7"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("5")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Departure of Sedrak Adoian")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c06",
      "id": "toctitle8"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("6")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Akhtamar")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781466817081_p02",
      "id": "toctitle9"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART II")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c07",
      "id": "toctitle10"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("7")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("To Van")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c08",
      "id": "toctitle11"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("8")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The American Mission at Van")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c09",
      "id": "toctitle12"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("9")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Massacres")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c10",
      "id": "toctitle13"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("10")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Siege of Van")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c11",
      "id": "toctitle14"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("11")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Our Fatherland")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781466817081_p03",
      "id": "toctitle15"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART III")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c12",
      "id": "toctitle16"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("12")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Flight into Russia")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c13",
      "id": "toctitle17"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("13")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Yerevan")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c14",
      "id": "toctitle18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("14")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Famine")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781466817081_p04",
      "id": "toctitle19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART IV")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c15",
      "id": "toctitle20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("15")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Watertown and Providence")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c16",
      "id": "toctitle21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("16")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Young Master")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781466817081_p05",
      "id": "toctitle22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART V")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c17",
      "id": "toctitle23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("17")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Early Years in New York")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c18",
      "id": "toctitle24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("18")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Apprentice to the Masters")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c19",
      "id": "toctitle25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("19")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Teaching")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c20",
      "id": "toctitle26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("20")]), _vm._v(" - "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Artist and His Mother")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c21",
      "id": "toctitle27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("21")]), _vm._v(" - "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Portrait of Myself and My Imaginary Wife")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c22",
      "id": "toctitle28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("22")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Cafeteria People")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c23",
      "id": "toctitle29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("23")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Copy Art and Imitate Nature")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781466817081_p06",
      "id": "toctitle30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART VI")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c24",
      "id": "toctitle31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("24")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Another Cup of Coffee, Another Piece of Pie")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c25",
      "id": "toctitle32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("25")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Fervent Scrutinizer")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c26",
      "id": "toctitle33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("26")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Exhibitions")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c27",
      "id": "toctitle34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("27")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Marny George")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c28",
      "id": "toctitle35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("28")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Corinne")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c29",
      "id": "toctitle36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("29")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Lyrical Man")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781466817081_p07",
      "id": "toctitle37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART VII")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c30",
      "id": "toctitle38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("30")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Artists’ Union and the American Abstract Artists")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c31",
      "id": "toctitle39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("31")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Newark Airport Murals")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c32",
      "id": "toctitle40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("32")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("“Deeper and Purer Work”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c33",
      "id": "toctitle41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("33")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Armenian Portraits")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c34",
      "id": "toctitle42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("34")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The End of the Decade")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c35",
      "id": "toctitle43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("35")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("A Language for All to Understand")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781466817081_p08",
      "id": "toctitle44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART VIII")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c36",
      "id": "toctitle45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("36")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Mougouch")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c37",
      "id": "toctitle46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("37")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Cohabitation")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c38",
      "id": "toctitle47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("38")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("San Francisco")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c39",
      "id": "toctitle48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("39")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Marriage")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c40",
      "id": "toctitle49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("40")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Garden in Sochi")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c41",
      "id": "toctitle50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("41")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Camouflage")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781466817081_p09",
      "id": "toctitle51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART IX")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c42",
      "id": "toctitle52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("42")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Surrealists in Exile")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c43",
      "id": "toctitle53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("43")]), _vm._v(" - "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Waterfall")])])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781466817081_p10",
      "id": "toctitle54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART X")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c44",
      "id": "toctitle55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("44")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Virginia")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c45",
      "id": "toctitle56",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("45")]), _vm._v(" - "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Leaf of the Artichoke Is an Owl")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c46",
      "id": "toctitle57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("46")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Cutting Down the Raphaels")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c47",
      "id": "toctitle58",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("47")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("November and December in New York")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781466817081_p11",
      "id": "toctitle59",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART XI")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c48",
      "id": "toctitle60",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("48")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Roxbury")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c49",
      "id": "toctitle61",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("49")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Eye-Spring")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c50",
      "id": "toctitle62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("50")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Fearfully Linked with the Sun")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781466817081_p12",
      "id": "toctitle63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART XII")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c51",
      "id": "toctitle64",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("51")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Sherman")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c52",
      "id": "toctitle65",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("52")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Phoenix")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c53",
      "id": "toctitle66",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("53")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("A Tree Cut Down")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c54",
      "id": "toctitle67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("54")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Sky Miner’s Haul")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c55",
      "id": "toctitle68",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("55")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Third Virginia Summer")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781466817081_p13",
      "id": "toctitle69",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART XIII")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c56",
      "id": "toctitle70",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("56")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Gorky and the Surrealists")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c57",
      "id": "toctitle71",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("57")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Castine")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781466817081_p14",
      "id": "toctitle72",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART XIV")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c58",
      "id": "toctitle73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("58")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Glass House")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c59",
      "id": "toctitle74",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("59")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Show at Julien Levy")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c60",
      "id": "toctitle75",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("60")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("No More Ploughs")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c61",
      "id": "toctitle76",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("61")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Peeled Onion")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c62",
      "id": "toctitle77",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("62")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Darkness Spreads over My Soul")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781466817081_p15",
      "id": "toctitle78",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART XV")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c63",
      "id": "toctitle79",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("65")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Aftermath")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466817081_c64",
      "id": "toctitle80",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("64")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Fame")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_alsoby",
    attrs: {
      "href": "#/e9781466817081_als01",
      "id": "toctitle81",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ALSO BY HAYDEN HERRERA")])])]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781466817081_bm01",
      "id": "toctitle82",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NOTES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781466817081_bm02",
      "id": "toctitle83",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Notes")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781466817081_bm03",
      "id": "toctitle149",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Selected Bibliography")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781466817081_ack01",
      "id": "toctitle164",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acknowledgments")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_index",
    attrs: {
      "href": "#/e9781466817081_ind01",
      "id": "toctitle165",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Index")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781466817081_bm04",
      "id": "toctitle166",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Art Acknowledgments")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781466817081_cop01",
      "id": "toctitle168",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2715cdda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466817081_toc01.vue
// module id = 66
// module chunks = 0